import {createClient} from 'contentful';

const client = createClient({
    space: '6q7zicmvbyor',
    accessToken:'0aMc_dR1oPQLO11Ts726mSH99fQuZFJ5P-3tGR8OmM4'         
})
export default client;